import locale77427e78 from '../../lang/en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"default","numberFormats":{"default":{"currency":{"style":"currency","currency":"INR","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"default","label":"English","file":"en.js","iso":"en_IN","defaultCurrency":"INR"}],
  defaultLocale: "default",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "/var/www/venusdigitalarcade.in/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  seo: true,
  baseUrl: "https://venusdigitalarcade.in",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  country: "IN",
  useNuxtI18nConfig: false,
  autoRedirectByLocale: false,
  normalizedLocales: [{"code":"default","label":"English","file":"en.js","iso":"en_IN","defaultCurrency":"INR"}],
  localeCodes: ["default"],
}

export const localeMessages = {
  'en.js': () => Promise.resolve(locale77427e78),
}
